import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

import { AccountHeaderItemType } from '@digital-platform/rs-header-services';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@Component({
  selector: 'digital-platform-account-header-item',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './account-header-item.component.html',
  styleUrls: ['./account-header-item.component.scss'],
})
export class AccountHeaderItemComponent {
  @Input() item!: AccountHeaderItemType;
  @Output() itemClicked = new EventEmitter<AccountHeaderItemType>();

  private isHovered = false;

  onClick() {
    this.itemClicked.emit(this.item);
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.isHovered = true;
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.isHovered = false;
  }

  get icon(): string {
    return this.item.selected || this.isHovered
      ? this.item.svgIconHover
      : this.item.svgIcon;
  }
}
